import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { FOOTER, CONTACT } from "../../data/site";
import { NewsletterForm } from "../site/NewsletterForm";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-brand-ink text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_2fr]">
          <div>
            <div className="inline-flex bg-white p-3">
              <img src="/logo.webp" alt="MATRIVON" width="480" height="480" loading="lazy" decoding="async" className="h-20 w-auto" />
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              Independent commercial and industrial advisory for international markets — connecting
              markets, commercial decisions and technical reality.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/70">
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-2 hover:text-white">
                <Mail className="h-4 w-4" /> {CONTACT.email}
              </a>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="flex items-center gap-2 hover:text-white">
                <Phone className="h-4 w-4" /> {CONTACT.phone}
              </a>
            </div>
            <div className="mt-8 max-w-sm">
              <div className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-white/50">
                Subscribe to MATRIVON Insights
              </div>
              <NewsletterForm source="footer" dark />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
            {FOOTER.columns.map((col) => (
              <div key={col.title}>
                <div className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/50">
                  {col.title}
                </div>
                <ul className="space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.to}>
                      <Link
                        to={l.to}
                        className="text-sm text-white/70 transition-colors hover:text-white"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row">
          <span>© {new Date().getFullYear()} MATRIVON. All rights reserved.</span>
          <span>Independent Commercial and Industrial Intelligence for Better Business Decisions.</span>
        </div>
      </div>
    </footer>
  );
};
